import React from 'react';

const Spinner = () => <div id='spinner'/>;

export default Spinner;
